module.exports = __webpack_public_path__ + "img/pro-uav.6bab01b0.png";